<template>
  <div class="container report">
    <breadcrumb crumb="load-day" />
    <section class="top-section shipping_list">
      <el-row v-loading="!loaded" :gutter="24" class="ts_row">
        <el-col :span="14">
          <header-load-day
            v-if="loaded"
            :bid="bid"
            :report="report"
            :load-days="loadDays"
            :responses="responses"
          />
        </el-col>
        <el-col :span="10" class="ts_col">
          <additional-menu v-if="loaded" :report="report" :bid="bid" />
        </el-col>
      </el-row>
      <el-row v-if="loaded" :gutter="24" class="ts_row">
        <response-list
          v-if="loaded"
          :bid="bid"
          :report="report"
          :load-days="loadDays"
          :responses="responses"
          :fetch-store="fetchStore"
          :pagination="pagination"
        />
      </el-row>
    </section>
  </div>
</template>

<script>
import { FETCH_ALL } from '@/store/actions/reports'
import { mapGetters } from 'vuex'
import AdditionalMenu from '@/views/Report/Components/AdditionalMenu'
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb'
import HeaderLoadDay from '@/views/Report/Components/Header'
import ResponseList from '@/views/Report/Components/Responses/ResponseList'

export default {
  name: 'Report',
  components: {
    HeaderLoadDay,
    AdditionalMenu,
    ResponseList,
    Breadcrumb,
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      bid: 'reports/getBid',
      report: 'reports/getCurrentReport',
      loadDays: 'reports/getLoadDays',
      responses: 'reports/getResponses',
      loaded: 'reports/getLoaded',
      pagination: 'reports/getPagination',
    }),
  },
  async mounted() {
    await this.fetchStore()
  },
  methods: {
    async fetchStore() {
      const paramsUrl = {
        reportId: this.$route.params.reportId,
        bidId: this.$route.params.bidId,
        currentPage: this.getCurrentPage(),
      }

      await this.$store.dispatch(`reports/${FETCH_ALL}`, paramsUrl)
    },
    getCurrentPage() {
      return this.$route.query.page ? this.$route.query.page : 1
    },
  },
}
</script>

<style lang="sass">
.shipping_list
  .shipping_card
    margin-bottom: 20px
    box-shadow: none
    &:hover
      transition: all 0.2s
      box-shadow: 0 2px 16px rgba(0, 0, 0, 0.12)
    .shipping_info
      padding-bottom: 10px
      min-height: 150px
      .sh-span
        font-size: 14px
        .sh-comment
          color: #409EFF
          border-bottom: 1px solid
          cursor: pointer
      .progress-block
        margin-bottom: 5px
        p
          margin: 0 0 5px
          font-family: Tahoma, sans-serif
          font-size: 14px
          color: rgba(0, 0, 0, 0.47)
          span
            color: rgba(0, 0, 0, 0.81)
            &.capitalize
              text-transform: capitalize
        .el-progress
          position: absolute
          width: 100%
      .sh_dist
        display: flex
        flex-direction: column
        margin: 0 15px
        align-items: center
      .number_date
        font-size: 14px
        line-height: 17px
        color: rgba(0, 0, 0, 0.47)
        border-radius: 5px
        margin-bottom: 0
        &.green
          color: #00bf40
      .distance
        font-size: 24px
        line-height: 17px
        color: #000000
        display: flex
        align-items: center
        justify-content: flex-end
        margin: 10px 0
        img
          margin-right: 10px
      .d_h2
        margin: 0
      .time
        font-size: 14px
        line-height: 17px
        color: rgba(0, 0, 0, 0.47)
        border-radius: 5px
        margin: 0 0 15px 0
        span
          margin: 0 5px
      .shipping-row
        display: flex
        align-items: center
        p
          font-size: 12px
          line-height: 17px
          &.ri_p1
            color: rgba(0, 0, 0, 0.5)
          &.ri_p2
            color: #000000
      .shipping-h2
        margin-bottom: 0
        display: flex
        justify-content: center
      .shipping_info_right
        text-align: right
        .weight
          font-size: 14px
          line-height: 17px
          color: rgba(0, 0, 0, 0.7)
          border-radius: 5px
      .day-status
        font-size: 0.9em
        color: #f00 !important
      .day-report
        margin-left: 5px
        font-size: 0.9em
        color: #67C23A !important
</style>
